/**
 * @file: TagOptionMenu.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { AppMenu } from '@euler/components/holdmenu/AppHoldMenu';
import { getDefectiveLevel } from '@euler/functions/getDefectiveLevel';
import { memo, useMemo } from 'react';
import { AnnotationTagOption } from '../functions/AnnotationTagOption';
import { TagOptionMenuItem } from './TagOptionMenuItem';

/**
 * The popup menu listing the result options a tag can stand for.
 */
export const TagOptionMenu = memo(
  ({
    options,
    selectedOptionId,
    onSelect,
  }: {
    options: AnnotationTagOption[];
    selectedOptionId?: number;
    onSelect: (option: AnnotationTagOption) => void;
  }) => {
    // listed as a scale, from the least to the most defective result.
    const sortedOptions = useMemo(
      () =>
        [...options].sort(
          (x, y) =>
            getDefectiveLevel(x.abnormalLevel, x.severityLevel) -
              getDefectiveLevel(y.abnormalLevel, y.severityLevel) ||
            x.severityLevel - y.severityLevel,
        ),
      [options],
    );

    return (
      <AppMenu>
        {sortedOptions.map(option => (
          <TagOptionMenuItem
            key={option.id}
            option={option}
            selected={option.id === selectedOptionId}
            onPress={onSelect}
          />
        ))}
      </AppMenu>
    );
  },
);
